import * as React from 'react';
import { connect } from 'react-redux';
import { FileUploadModal } from '@mitchell/react.component.ux';
import { getFileUploadErrorSummaryMessages, getModalFileDataList, isFileUploadModalOpen, getUploadRetryableFailedFiles, getFileUploadCanceledCount, isFileUploadModalRetryAllEnabled } from '../../selectors';
import { withI18n } from 'react-i18next';
import { ConvertBytesToMegaBytes, TranslationService } from "../../../common";
import { closeFileUploadModalAction, singleFileUploadCancelAction, retryFilesUploadStartAction } from '../../actions';
const mapStateToProps = (state, ownProps) => {
    return {
        files: getModalFileDataList(state),
        errorMessages: ownProps.errorMessages ? getFileUploadErrorSummaryMessages(state, ownProps.errorMessages) : [],
        isOpen: isFileUploadModalOpen(state),
        showRetryAll: isFileUploadModalRetryAllEnabled(state),
        uploadFailedFiles: getUploadRetryableFailedFiles(state),
        canceledUploadCount: getFileUploadCanceledCount(state),
        isEnhancedPhotoCaptureEnabled: false
    };
};
const mapDispatchToProps = (dispatch, ownProps) => ({
    onClose: () => {
        dispatch(closeFileUploadModalAction());
    },
    onCancel: (id) => {
        dispatch(singleFileUploadCancelAction(id));
    },
    onRetryUploadFailedFiles: (files) => {
        if (files.length > 0) {
            dispatch(retryFilesUploadStartAction(Object.assign({ files }, (ownProps.onRetryUploadComplete && { onAllFileUploadComplete: ownProps.onRetryUploadComplete }))));
        }
    }
});
const mergedProps = (stateProps, dispatchProps, ownProps) => {
    const { files, errorMessages, isOpen, showRetryAll, canceledUploadCount, uploadFailedFiles, isEnhancedPhotoCaptureEnabled } = stateProps;
    const { onClose, onCancel, onReupload, onRetryUploadFailedFiles } = dispatchProps;
    const { doneButtonId, shouldShowCompleted, handleShowCompletedChange, fileUploadModalId } = ownProps;
    const maxVideoFileSize = ownProps.maxVideoFileSize !== undefined ? ConvertBytesToMegaBytes(ownProps.maxVideoFileSize) : undefined;
    return {
        doneButtonId,
        shouldShowCompleted,
        handleShowCompletedChange,
        fileUploadModalId,
        files,
        errorMessages,
        isOpen,
        showRetryAll,
        canceledUploadCount,
        onClose,
        onCancel,
        onReupload,
        onRetryAll: () => onRetryUploadFailedFiles(uploadFailedFiles),
        maxVideoFileSize,
        isEnhancedPhotoCaptureEnabled
    };
};
const ConnectedFileUploadModalWithI18n = (props) => (React.createElement(FileUploadModal, Object.assign({}, props, { translateFn: TranslationService.translate })));
export const ConnectedFileUploadModal = withI18n()(connect(mapStateToProps, mapDispatchToProps, mergedProps)(ConnectedFileUploadModalWithI18n));
//# sourceMappingURL=ConnectedFileUploadModal.js.map